module.exports = __webpack_public_path__ + "static/media/level_05-06.7a792193.jpg";